import React from 'react';
import { FaUsers, FaUserPlus, FaInfoCircle } from 'react-icons/fa';
import { useRoster } from './hooks/useRoster';
import './BenchedStaffPanel.css';

const BenchedStaffPanel = () => {
  const { benchedStaff, activateStaff } = useRoster();

  return (
    <div className="benched-staff-card">
      <div className="benched-staff-header">
        <div className="benched-staff-title">
          <FaUsers className="title-icon" />
          Emergency Staff Pool
        </div>
        <div className="benched-staff-subtitle">Staff available for emergency coverage</div>
      </div>
      <div className="benched-staff-content">
        {/* Info Banner */}
        <div className="info-banner">
          <div className="info-content">
            <FaInfoCircle className="info-icon" />
            <div className="info-text">
              <p className="info-title">Drag & Drop Available</p>
              <p className="info-description">Drag staff from this panel to roster slots for emergency coverage</p>
            </div>
          </div>
        </div>

        <div className="separator"></div>

        {/* Benched Staff List */}
        <div className="staff-list">
          {benchedStaff.map(staff => (
            <div
              key={staff.id}
              className="staff-card"
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData('staff', JSON.stringify(staff));
              }}
            >
              <div className="staff-info">
                <div className="staff-avatar">
                  {staff.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div className="staff-details">
                  <div className="staff-name-row">
                    <h4 className="staff-name">{staff.name}</h4>
                  </div>
                  <p className="staff-position">{staff.position}</p>
                  <div className="staff-skills">
                    {staff.skills.slice(0, 2).map(skill => (
                      <span key={skill} className="skill-badge">
                        {skill}
                      </span>
                    ))}
                    {staff.skills.length > 2 && (
                      <span className="skill-badge">
                        +{staff.skills.length - 2}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="separator"></div>
              
              <button
                className="activate-btn"
                onClick={() => activateStaff(staff.id)}
              >
                <FaUserPlus className="btn-icon" />
                Activate for Roster
              </button>
            </div>
          ))}
        </div>

        {benchedStaff.length === 0 && (
          <div className="empty-state">
            <FaUsers className="empty-icon" />
            <p className="empty-text">
              No staff in emergency pool
            </p>
          </div>
        )}

        <div className="separator"></div>

        {/* Quick Stats */}
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number">{benchedStaff.length}</div>
            <div className="stat-label">Available</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">{benchedStaff.reduce((acc, staff) => acc + staff.skills.length, 0)}</div>
            <div className="stat-label">Total Skills</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenchedStaffPanel;